export default "__VITE_ASSET__qnVn6xy$__"